import NotificationType from '../NotificationType';

export default class UserImportFailed extends NotificationType {
  get icon() {
    return 'fa-solid fa-circle-exclamation';
  }

  resolveRoute(notification) {
    const id = notification?.params?.user_csv_import_id;
    if (!id) return { name: 'admin-users-listing' };
    return { name: 'admin-user-csv-import-results', params: { id } };
  }
}
